import React from 'react';
import { BaseHint } from 'components';
import { Intent } from 'constants/ui';
import './ManuallyAddBankAccountErrorHint.scss';
const ManuallyAddBankAccountErrorHint = ({ company }) => (React.createElement("div", { className: "manually-add-bank-account-error-hint" },
    React.createElement(BaseHint, { intent: Intent.DANGER, text: `An error occurred while trying to add your payment method. Please reach out to ${company.name} to resolve the issue with your payment.`, title: "Error", titleProps: { className: 'font-color--red--bold--important' } })));
export default ManuallyAddBankAccountErrorHint;
